import { render, staticRenderFns } from "./AddressStamp.vue?vue&type=template&id=7d8568e3&scoped=true&lang=pug"
import script from "./AddressStamp.vue?vue&type=script&lang=js"
export * from "./AddressStamp.vue?vue&type=script&lang=js"
import style0 from "./AddressStamp.vue?vue&type=style&index=0&id=7d8568e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8568e3",
  null
  
)

export default component.exports